import { render, staticRenderFns } from "./AccommodationsLedgerAccountsTable.vue?vue&type=template&id=c06a8792&"
import script from "./AccommodationsLedgerAccountsTable.vue?vue&type=script&lang=js&"
export * from "./AccommodationsLedgerAccountsTable.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationsLedgerAccountsTable.vue?vue&type=style&index=0&id=c06a8792&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports